<template>
  <div>
    <Header></Header>
    <section class="top">

    </section>
    <el-container class='middle'>
      <!-- 列表 -->
      <el-aside width="25%">
        <div class="Tabul">产品分类</div>
        <div class="menu-top" :class="classify==1?'menu-tops':''"  @click="Handover(1)"><img src="../../static/img/dajiao.gif"  alt="">工业物联</div>
        <div class="menu-list">
          <div class="menu-list-tob" :class="id == item.id?'Select':''" v-for="(item,i) in Tabledata.Industrial" @click="goProduct(item.id)"><img src="../../static/img/xiaojiao.gif" alt="">{{item.title}}</div>
        </div>
        <div class="menu-top" :class="classify==2?'menu-tops':''" @click="Handover(2)"><img src="../../static/img/dajiao.gif" alt=""  >智慧水务</div>
        <div class="menu-list">
          <div class="menu-list-tob" :class="id == item.id?'Select':''" v-for="(item,i) in Tabledata.dieslab" @click="goProduct(item.id)"><img src="../../static/img/xiaojiao.gif" alt="">{{item.title}}</div>
        </div>
      </el-aside>
      <!-- 产品 -->
      <el-main>
        <el-row>
          <el-col :span="10">
              <vue-photo-zoom-pro
                :url="content.url"
                :out-zoomer="true"
                :mask='false'
                :scale='2.5'
                :zoomer-style="{'background-color': 'transparent'  }"
                type='square'>
              <template  slot="zoomer">
                <div class="ks-imagezoom-wrap"></div>
              </template>
              </vue-photo-zoom-pro>
            </el-col>
          <el-col :span="14">
            <h1>{{content.title}}</h1>
            <div class="text">{{content.text}}</div>
            <div class="returnbtn" @click="Handover">
              返回列表
            </div>
         <div class="Jump">
            <span @click="Solution"><i class="el-icon-s-tools" style="color: #0C55A4;font-size: 18px;vertical-align: text-bottom;"></i>解决方案</span>
            <span @click="goto('aboutus','productId')"><i class="el-icon-s-comment" style="color: #0C55A4; font-size: 18px;vertical-align: text-bottom;"></i>在线留言</span>
         </div>
         </el-col>
         </el-row>

         <div class="content">
            <div class="title">产品优势</div>
            <div class="card">
              <div class="description">
                <div>{{content.text2}}</div>
                <img :src="item" alt="" v-for="(item,i) in content.img" :key='i' >
              </div>
            </div>

         </div>

          </el-col>

        </el-row>
      </el-main>
    </el-container>
    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        btnCor: 0,
        // 全部数据
        listdata:[],
        // 左侧栏数据
        Tabledata:{
          Industrial:[],//工业物联
          dieslab:[],//智慧水务
        },
        content:{},
        // 分类
        classify:0,
        // 标识
        id:""
      }
    },
    mounted(){
      this.listdata = this.template
      // 传过来的参数切换产品
      console.log(this.$route);
      this.goProduct(this.$route.query.tid)
      for (var i = 0; i < this.listdata.length; i++) {
        if(this.listdata[i].type==1){
          this.Tabledata.Industrial.push(this.listdata[i])
        }else if(this.listdata[i].type==2){
          this.Tabledata.dieslab.push(this.listdata[i])
        }
      }
      document.body.onmousewheel = event => {
        event = event || window.event
        event.preventDefault()
        this.scale += event.deltaY > 0 ? -0.1 : 0.1
      }
    },
    methods: {
      // 切换分类
      Handover(type){
        this.$router.push({ name: 'Electricity', query: { tid: type }})
      },
      // 切换产品
      goProduct(id){
        if(id==undefined){
          id = 1
        }
        this.id = id
        this.content = {}
        for (var i = 0; i < this.listdata.length; i++) {
          if(id== this.listdata[i].id){
            this.content = this.listdata[i]
            console.log(this.content);
          }
        }
      },
      // 解决方案
      Solution(){
        this.$router.push({name:'Information', query: {id:this.id}});
      },
      // 联系我们
      goto(page,selectId){
        var path = page;
        var selectId = selectId;
        localStorage.setItem("toId",selectId);
        this.$router.push({name: path, query: {info:true}});
      }
    }
  }
</script>

<style scoped lang="scss">

  .top {
    height: 460px;
    background-image: url(../../static/img/topbgimg3.png);
    background-repeat: no-repeat;
  }

  .middle {
    width: 94%;
    max-width: 1400px;
    min-width: 0px;
    height: auto;
    max-height: none;
    margin: 0 auto;

    .el-main {
      .el-row {
          .el-col:first-child{
           /deep/ .photo-zoom-pro {
             padding: 0 15px;
             .container{
                 padding: 0;
                 width: 420px !important;
                     height: 235px !important;
                 .img-out-show{
                   width: 500px;
                   height: 500px;
                 }
             }
           }
          }
          .el-col:nth-child(2){
            padding-left: 40px;
            h1{
              font-weight: 900;
              font-size: 22px;
            }
            .text{
                min-height: 168px;
                font-size: 14px;
                line-height: 1.8;
                color: #666;
                padding: 20px 0px;
                border-bottom: 1px solid #eee;
            }
            .returnbtn{
              float: left;
                margin-top: 10px;
                display: inline-block;
                margin-bottom: 10px;
                background: #0c55a4;
                padding: 0.6vw 3vw;
                border-radius: 0px;
                font-size: 16px;
                color: #fff;
                border: 1px solid #0c55a4;
                transition: 0.5s;
                cursor: pointer;
                &:hover{
                  background: #fff;
                  color: #0c55a4;
                }
            }
            .Jump{
              float: left;
              margin-top: 18px;
              span{
                    margin: 6px 20px 6px 0;
                    padding-left: 25px;
                    font-size: 14px;
                    height: 30px;
                    background: none;
                    color: #555;
                    line-height: 30px;
                    cursor: pointer;
                    &:hover{
                      color: #007dbc;
                    }
              }
            }
          }
        }
    }
      .content{
        margin-top: 20px;
        .title{
          display: inline-block;
          padding: 10px 20px;
              background-color: #0c55a4 ;
              font-size: 18px;
              font-weight: 900;
              color: #fff;
        }
        .card{
          border-top: 1px solid #d9d9d9;
          .description{
            padding: 20px;
            div{
              line-height: 1.8;
              color: #666;
              margin-bottom: 10px;
              font-size: 14px;
              white-space: pre-line;
            }
             img{
               width: 100%;
               margin-bottom: 10px;
             }
          }
        }

      }
  }
  .el-aside {
    padding: 20px;
    .Tabul {
      display: inline-block;
      // vertical-align: middle;
      line-height: 70px;
      color: rgba(255, 255, 255, 1);
      font-weight: normal;
      font-size: 30px;
      width: 100%;
      background-color: #226cb5;
      height: 70px;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .menu-top{
      &:hover{
        background: #00458e;
        color: #FFFFFF;
      }
      cursor: pointer;
      width: 100%;
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 16px;
      img{
        margin: 0 12px;
        margin-top: -6px;
      }
    }
   .Select{
      background: #00458e;
      color: #FFFFFF;
    }
    .menu-list{
      padding-left: 20px;
      .menu-list-tob{
        &:hover{
          background: #00458e;
          color: #FFFFFF;
        }
        cursor: pointer;
        width: 100%;
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #e8e8e8;
        font-size: 14px;
        img{
          margin: 0 8px;
          margin-top: -4px;
        }
      }
    }
  }

.ks-imagezoom-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(//gtms01.alicdn.com/tps/i4/T12pdtXaldXXXXXXXX-2-2.png) repeat
    scroll 0 0 transparent;
  cursor: move;
  z-index: 1;
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue